import { createContext } from 'react';
import { AmplienceMegaNavProps } from 'components/amplience/header-nav/components/mega-nav';

interface IMobileMenuContext {
  megaNavSelected: AmplienceMegaNavProps | undefined;
  setMegaNavSelected: (megaNav: AmplienceMegaNavProps | undefined) => void;
}

export const MobileMenuContext = createContext<IMobileMenuContext>({
  megaNavSelected: undefined,
  setMegaNavSelected: () => {},
});
